import { Box } from '@careguide/theme'
import Text from 'components/base/Text'
import styled from 'styled-components'
import css from '@styled-system/css'
import { FooterLinkSectionProps } from 'types/footer-links'
import Stack from '@careguide/stack'
import { Subheading } from '@careguide/typography'

const FooterLinkSection = ({ heading, linkArray, isJob }: FooterLinkSectionProps) => {
  return (
    <Stack gap='4'>
      <Subheading>{heading}</Subheading>
      <Box display='flex' flexWrap='wrap' role='list'>
        {linkArray.map((element, index) => (
          <Box display='flex' key={index} role='listitem'>
            <FooterLink href={isJob ? element.jobsDirectoryUrl : element.profilesDirectoryUrl}>
              <FooterText my={0} mr={2}>
                {element?.site?.directoryJobDescription || element?.name}
              </FooterText>
            </FooterLink>
            {index < linkArray.length - 1 && (
              <Text as='h5' my={0} pb={2} mr={2} variant='heading' aria-hidden>
                {' '}
                •{' '}
              </Text>
            )}
          </Box>
        ))}
      </Box>
    </Stack>
  )
}

const FooterLink = styled.a`
  text-decoration: none;
  font-size: inherit;
  font-weight: normal;
  cursor: pointer;
`

const FooterText = styled(Text).attrs({ as: 'h5', variant: 'heading' })`
  &:hover {
    ${css({ color: 'inverseColor' })}
    text-decoration: underline;
  }
`

export default FooterLinkSection
